import React, { useEffect, useState } from "react";
import { MdOutlineSignalCellularAlt, MdTrackChanges } from "react-icons/md";
import UsageModal from "../modals/UsageModal";
import { app_url } from "../../config";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import EsimDetailsModal from "../modals/EsimDetailsModal";
import Error500 from "../500/Error500";
import EsimLineActivityModal from "../modals/EsimLineActivityModal";
import { HiDotsHorizontal } from "react-icons/hi";
import { FaRegCopy } from "react-icons/fa";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Loader from "../Loader";

const PhysicalSimTable = ({ tabledata, isLoading }) => {
  const token = JSON.parse(localStorage.getItem("adminEtijwaal"))?.token;
  const [showModal, setShowModal] = useState(false);
  const [showEsimDetailModal, setShowEsimDetailModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showShareEsimModal, setShowShareEsimModal] = useState(false);
  const [showLineActivityModal, setShowLineActivityModal] = useState(false);
  const [email, setEmail] = useState("");
  const [eSimDetail, seteSimDetail] = useState(null);
  const [shareEsimDetail, setShareEsimDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [shareEsimLoading, setShareEsimLoading] = useState(false);
  const [selectedEsimData, setSelectedEsimData] = useState(null);
  const [eSimDetailLoader, seteSimDetailLoader] = useState(false);
  const [online, setOnline] = useState(false);
  const [failed, setFailed] = useState("");
  const [tableData, setTableData] = useState([]);
  const [selectedIccid, setSelectedIccid] = useState("");
  const [activeDropdownId, setActiveDropdownId] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [lineId, setLineId] = useState("");

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (activeDropdownId && !e.target.closest(".dropdown")) {
        setActiveDropdownId(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [activeDropdownId]);

  const handleCloseEsimModal = () => {
    setShowEsimDetailModal(false);
    setSelectedEsimData(null);
  };

  const handleOpneEsimModal = () => {
    setShowEsimDetailModal(true);
  };

  // const geteSimDetail = (lineId) => {
  //   handleOpneEsimModal();
  //   seteSimDetailLoader(true);
  //   axios
  //     .get(
  //       `${app_url}/api/line/getLineDetailsByLineIdforAportal?lineId=${lineId}`,
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       setSelectedEsimData(res?.data?.esim[0]);
  //       seteSimDetailLoader(false);
  //     })
  //     .catch((err) => {
  //       seteSimDetailLoader(false);
  //       handleCloseEsimModal();
  //       if (err.response) {
  //         if (err.response.status === 400) {
  //           toast.error(err.response.data.message || "Bad Request");
  //         } else if (err.response.status === 401) {
  //           toast.error(
  //             err.response.data.message ||
  //               "Unauthorized access. Please check your credentials. "
  //           );
  //         } else if (err.response.status === 500) {
  //           toast.error(err.response.data.message || "Internal Server Error");
  //           setFailed(
  //             "Server is currently unavailable. Please try again later."
  //           );
  //         } else {
  //           toast.error(
  //             err.response.data.message || "An unexpected error occurred."
  //           );
  //           setFailed(err.message);
  //         }
  //       } else {
  //         setOnline(true);
  //         setFailed("Network error. Please check your internet connection.");
  //       }
  //     });
  // };

  const newArr = new Array(12).fill(
    <p className="placeholder-glow">
      <span className="placeholder col-12"></span>
    </p>
  );

  const handleClose = () => {
    setShowModal(false);
    seteSimDetail(null);
  };
  const handleShow = () => setShowModal(true);

  // const handleResendEmail = () => {
  //   setShowEmailModal(true);
  // };

  const handleResendEmailClose = () => {
    setShowEmailModal(false);
  };

  // const handleShareEsim = (lineID) => {
  //   setShowShareEsimModal(true);
  //   setLoading(true);
  //   setLineId(lineID);
  //   axios
  //     .get(`${app_url}/api/line/shareEsimCloudLink?lineId=${lineID}`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     })
  //     .then((res) => {
  //       setShareEsimDetail(res?.data?.result);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //       setShowShareEsimModal(false);
  //       if (err.response) {
  //         if (err.response.status === 400) {
  //           toast.error(err.response.data.message || "Bad Request");
  //         } else if (err.response.status === 401) {
  //           toast.error(
  //             err.response.data.message ||
  //               "Unauthorized access. Please check your credentials. "
  //           );
  //         } else if (err.response.status === 500) {
  //           toast.error(err.response.data.message || "Internal Server Error");
  //           setFailed(
  //             "Server is currently unavailable. Please try again later."
  //           );
  //         } else {
  //           toast.error(
  //             err.response.data.message || "An unexpected error occurred."
  //           );
  //           setFailed(err.message);
  //         }
  //       } else {
  //         setOnline(true);
  //         setFailed("Network error. Please check your internet connection.");
  //       }
  //     });
  // };

  const sendEsimCloudLink = (phoneNumber) => {
    if (phoneNumber) {
      setShareEsimLoading(true);
    }
    axios
      .get(
        `${app_url}/api/line/shareEsimCloudLink_to_whatsapp?lineId=${lineId}&wa_number=${phoneNumber}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        toast.success(res.data.message);
        setShareEsimLoading(false);
      })
      .catch((err) => {
        setShareEsimLoading(false);
        if (err.response) {
          if (err.response.status === 400) {
            toast.error(err.response.data.message || "Bad Request");
          } else if (err.response.status === 401) {
            toast.error(
              err.response.data.message ||
                "Unauthorized access. Please check your credentials. "
            );
          } else if (err.response.status === 500) {
            toast.error(err.response.data.message || "Internal Server Error");
            setFailed(
              "Server is currently unavailable. Please try again later."
            );
          } else {
            toast.error(
              err.response.data.message || "An unexpected error occurred."
            );
            setFailed(err.message);
          }
        } else {
          setOnline(true);
          setFailed("Network error. Please check your internet connection.");
        }
      });
  };

  const link = shareEsimDetail?.esim_link;
  const code = shareEsimDetail?.access_code;
  const formattedText = `${link} (Access code: ${code})`;

  const handleCopy = () => {
    // console.log("formattedText", formattedText);
    // if (formattedText) {
    //   navigator.clipboard.writeText(formattedText);
    //   toast.success("Copied to clipboard");
    // }

    navigator.clipboard.writeText(formattedText).then(() => {
      toast.success("Copied to clipboard");
    });
  };

  const handleWhatsAppShare = () => {
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
      formattedText
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const handleShareEsimClose = () => {
    setShowShareEsimModal(false);
    setShareEsimDetail(null);
    setLineId(null);
    setPhoneNumber("");
  };

  const handleSendEmail = () => {
    setShowEmailModal(false);
  };

  const fetcheSimDetail = (lineID) => {
    handleShow();
    setLoading(true);
    axios
      .get(`${app_url}/api/line/getMyEsimByLineIdAport?lineId=${lineID}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        seteSimDetail(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        handleClose();
        if (err.response) {
          if (err.response.status === 400) {
            toast.error(err.response.data.message || "Bad Request");
          } else if (err.response.status === 401) {
            toast.error(
              err.response.data.message ||
                "Unauthorized access. Please check your credentials. "
            );
          } else if (err.response.status === 500) {
            toast.error(err.response.data.message || "Internal Server Error");
            setFailed(
              "Server is currently unavailable. Please try again later."
            );
          } else {
            toast.error(
              err.response.data.message || "An unexpected error occurred."
            );
            setFailed(err.message);
          }
        } else {
          setOnline(true);
          setFailed("Network error. Please check your internet connection.");
        }
      });
  };

  const hnadleLineActivityModalShow = () => {
    setShowLineActivityModal(true);
  };

  const hnadleLineActivityModalClose = () => {
    setShowLineActivityModal(false);
    setTableData([]);
  };

  const fetchLineActivity = (lineID) => {
    setLoading(true);
    hnadleLineActivityModalShow();

    axios
      .post(
        `${app_url}/api/line/fetchLineActvityById_forAport`,
        { lineId: lineID },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setLoading(false);
        setTableData(res?.data);
        // console.log(res, "response check");
      })
      .catch((err) => {
        setLoading(false);
        hnadleLineActivityModalClose();
        if (err.response) {
          if (err.response.status === 400) {
            toast.error(err.response.data.message || "Bad Request");
          } else if (err.response.status === 401) {
            toast.error(
              err.response.data.message ||
                "Unauthorized access. Please check your credentials. "
            );
          } else if (err.response.status === 500) {
            toast.error(err.response.data.message || "Internal Server Error");
            setFailed(
              "Server is currently unavailable. Please try again later."
            );
          } else {
            toast.error(
              err.response.data.message || "An unexpected error occurred."
            );
            setFailed(err.message);
          }
        } else {
          setOnline(true);
          setFailed("Network error. Please check your internet connection.");
        }
      });
  };

  const skeleton = (
    <tbody>
      {newArr.map((item, index) => (
        <tr key={index}>
          <th scope="row" className="py-5 ps-5">
            {item}
          </th>
          <th scope="row" className="py-5">
            {item}
          </th>
          <th scope="row" style={{ textTransform: "none" }} className="py-5">
            {item}
          </th>
          <th scope="row" className="text-center py-5">
            {item}
          </th>
        </tr>
      ))}
    </tbody>
  );

  if (online) {
    return <Error500 message={failed} />;
  }

  return (
    <>
      <div
        className="table-responsive overflow-scroll"
        style={{ minHeight: "24em" }}
      >
        <table className="table sm:mt-4 mt-3 table-tb">
          <thead className="">
            <tr className="rounded">
              <th
                className="tr-tt fw-bold ps-5"
                scope="col"
                style={{ textTransform: "none" }}
              >
                eSIM
              </th>
              <th className="tr-tt fw-bold" scope="col">
                ICCID & ISSUE DATE
              </th>
              <th className="tr-tt fw-bold" scope="col">
                USER
              </th>
              <th className="tr-tt fw-bold" scope="col">
                ACTIONS
              </th>
            </tr>
          </thead>

          {isLoading ? (
            skeleton
          ) : (
            <tbody>
              {tabledata?.data?.result.length == 0 ? (
                <tr>
                  <th className="py-4"></th>
                  <th className="py-4"></th>
                  <th className="py-4 align-middle">No Data Found</th>
                  <th className="py-4"></th>
                </tr>
              ) : (
                tabledata?.data?.result.map(
                  (
                    {
                      id,
                      iccid,
                      carrierName,
                      image,
                      first_name,
                      last_name,
                      packageName,
                      email,
                      type,
                      createdAt,
                      agent_name,
                      sim_installation_status,
                    },
                    index
                  ) => (
                    <tr className="">
                      <th className="py-4 align-middle esim_flag ps-5">
                        <div className="d-flex gap-2 align-items-center">
                          <img
                            src={app_url + image}
                            alt="flag image"
                            loading="lazy"
                          />
                          <p className="mb-0">
                            {" "}
                            {packageName} <br />({type})
                          </p>
                        </div>
                      </th>
                      <th className="py-4 align-middle">
                        <div>
                          {" "}
                          {iccid} <br /> {carrierName} <br />
                          {new Date(createdAt).toLocaleString()}
                        </div>
                      </th>
                      <th className="py-4 align-middle">
                        <div>
                          {first_name} {last_name}
                          <br />
                          <span className="text-lowercase">{email}</span>
                          <br />
                          {agent_name !== null && (
                            <>
                              <span className="fw-bold">Agent: </span>
                              {agent_name}
                            </>
                          )}
                        </div>
                      </th>

                      <th className="py-4 align-middle position-relative">
                        <div className="dropdown">
                          <HiDotsHorizontal
                            size={28}
                            className="p-1 shadow rounded cursor-pointer"
                            style={{ borderRadius: "5px" }}
                            role="button"
                            title="click action"
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveDropdownId((prev) =>
                                prev === id ? null : id
                              );
                            }}
                          />

                          <div
                            className={`dropdown-menu shadow fade ${
                              activeDropdownId === id ? "show" : ""
                            }`}
                            style={{
                              width: "12em",
                              display:
                                activeDropdownId === id ? "block" : "none",
                              transition: "opacity 0.3s ease-in-out",
                              right: 0,
                              left: "-140px",
                              position: "absolute",
                              zIndex: 1000,
                            }}
                          >
                            <div className="d-flex flex-column gap-2">
                              {/* <div
                                className="d-flex items-center pointer px-4 py-1 gap-2 border-bottom"
                                style={{
                                  borderColor: "#E9ECEF",
                                  textTransform: "none",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleResendEmail();
                                }}
                                title="Send Email"
                              >
                                <IoIosSend size={20} className="" />
                                <p className="mb-0">Send Email</p>
                              </div> */}
                              {/* <div
                                className="d-flex items-center pointer px-4 py-1 gap-2 border-bottom"
                                style={{
                                  borderColor: "#E9ECEF",
                                  textTransform: "none",
                                }}
                                onClick={() => handleShareEsim(id)}
                                title="Share eSIM"
                              >
                                <MdOutlineShare size={20} className="" />
                                <p className="mb-0">Share eSIM</p>
                              </div> */}
                              <div
                                className="d-flex items-center pointer px-4 py-1 gap-2 border-bottom"
                                onClick={() => fetcheSimDetail(id)}
                                style={{
                                  borderColor: "#E9ECEF",
                                  textTransform: "none",
                                }}
                                title="eSIM Usage"
                              >
                                <MdOutlineSignalCellularAlt
                                  size={20}
                                  className=""
                                />
                                <p className="mb-0">SIM Usage</p>
                              </div>

                              {/* <div
                                className="d-flex items-center pointer px-4 py-1 gap-2 border-bottom"
                                onClick={() => geteSimDetail(id)}
                                style={{
                                  borderColor: "#E9ECEF",
                                  textTransform: "none",
                                }}
                                title="eSIM Details"
                              >
                                <img
                                  src={esimDetailIcon}
                                  width={20}
                                  height={20}
                                  alt="Detail Icon"
                                />
                                <p className="mb-0 font-normal">eSIM Details</p>
                              </div> */}

                              <div
                                className="d-flex items-center pointer px-4 py-1 gap-2 "
                                onClick={() => {
                                  setSelectedIccid(iccid);
                                  fetchLineActivity(id);
                                }}
                                style={{
                                  textTransform: "none",
                                }}
                                title="Line Activity"
                              >
                                <MdTrackChanges size={20} className="" />
                                <p className="mb-0">Line Activity</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </th>
                    </tr>
                  )
                )
              )}
            </tbody>
          )}
        </table>
      </div>
      <UsageModal
        show={showModal}
        handleClose={handleClose}
        eSimDetail={eSimDetail}
        isLoading={loading}
      />
      {/* Send Email Modal */}
      {showEmailModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Send Email</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleResendEmailClose}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label htmlFor="emailInput" className="form-label">
                      Email address
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="emailInput"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter email"
                      required
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSendEmail}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {/* Share Esim Modal */}
      {showShareEsimModal && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal fade show" style={{ display: "block" }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Share eSIM</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleShareEsimClose}
                  ></button>
                </div>

                {loading ? (
                  <div
                    style={{
                      height: "20vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "8em",
                    }}
                  >
                    <Loader />
                  </div>
                ) : (
                  <div className="modal-body">
                    <div className="d-flex flex-column gap-4">
                      <div className="bg-light rounded shadow px-2 py-1 position-relative">
                        <div
                          onClick={handleCopy}
                          className="d-flex align-items-center pointer border-0 py-2 position-absolute end-0 top-0 pe-2"
                          title="Copy to Clipboard"
                        >
                          <FaRegCopy size={20} />
                        </div>
                        <div className="px-2">
                          <p className="text-primary fw-semibold mb-1">
                            eSIM Cloud Link
                          </p>
                          <div className="d-flex justify-content-between align-items-center   ">
                            <p
                              className="mb-0 "
                              style={{ wordBreak: "break-all" }}
                            >
                              {link}
                            </p>
                          </div>
                        </div>
                        <hr className="my-2" />
                        <div className="d-flex gap-2 justify-content-between px-2">
                          <div className=" ">
                            <p className="fw-semibold mb-1">Access Code</p>
                            <div className="d-flex justify-content-between align-items-center ">
                              <p className="mb-0">{code}</p>
                            </div>
                          </div>
                          <div className="">
                            <p className="fw-semibold mb-1">Expiry</p>
                            <div className="d-flex justify-content-between align-items-center ">
                              <p className="mb-0">
                                {new Date(
                                  shareEsimDetail?.expiry
                                ).toLocaleString()}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="bg-light rounded shadow px-2 py-2 position-relative">
                        {shareEsimDetail?.wa_number !== null && (
                          <>
                            <div
                              className="text-primary pointer"
                              style={{ textDecoration: "underline" }}
                              onClick={() =>
                                sendEsimCloudLink(shareEsimDetail?.wa_number)
                              }
                            >
                              Click here to send Link on Whatsapp (
                              {shareEsimDetail?.wa_number})
                            </div>
                            <p className="fw-semibold my-2 text-center">OR</p>{" "}
                          </>
                        )}
                        <p className="mb-0 fw-semibold ">
                          Send Link to other Whatsapp Number
                        </p>
                        <div className="d-flex gap-2">
                          <PhoneInput
                            value={phoneNumber}
                            name="number"
                            id="phoneNumber"
                            country={"bh"}
                            onChange={(phone) => setPhoneNumber(phone)}
                            inputProps={{
                              name: "phone",
                              required: true,
                              autoFocus: true,
                            }}
                            containerStyle={{ width: "200px" }}
                            inputStyle={{
                              width: "100%",
                            }}
                          />
                          <button
                            type="button"
                            className="btn btn-primary"
                            onClick={() => sendEsimCloudLink(phoneNumber)}
                            disabled={shareEsimLoading}
                          >
                            Send
                            {shareEsimLoading ? (
                              <span
                                className="spinner-border spinner-border-sm"
                                aria-hidden="true"
                              ></span>
                            ) : (
                              ""
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {selectedEsimData && (
        <EsimDetailsModal
          show={showEsimDetailModal}
          esimData={selectedEsimData}
          onClose={handleCloseEsimModal}
          isLoading={eSimDetailLoader}
        />
      )}

      {showLineActivityModal && (
        <div
          className={`modal fade ${
            showLineActivityModal ? "show d-block" : ""
          }`}
          tabIndex="-1"
          style={{
            backgroundColor: showLineActivityModal
              ? "rgba(0, 0, 0, 0.5)"
              : "transparent",
          }}
        >
          <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Line Activity ({selectedIccid})</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={hnadleLineActivityModalClose}
                ></button>
              </div>
              <EsimLineActivityModal
                tableData={tableData}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default PhysicalSimTable;
